<template>
  <section class="core-values-section">
    <div class="section-container">

      <!-- 标题区域 -->
      <div class="header">
        <div class="tag">OUR FOUNDATION</div>
        <h2 class="title">Core <span class="gradient">Values & Principles</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 核心卡片网格 -->
      <div class="grid">
        <div v-for="(value, index) in values" :key="index" class="card">
          <!-- 右上角半透明水印数字 -->
          <div class="card-num">{{ String(index + 1).padStart(2, '0') }}</div>

          <!-- 图标 -->
          <div class="icon-box">
            <span class="icon">{{ value.icon }}</span>
          </div>

          <!-- 文本内容 -->
          <h3 class="card-title">{{ value.title }}</h3>
          <p class="card-desc">{{ value.desc }}</p>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'CoreValues',
  data() {
    return {
      values: [
        {
          icon: '🔍',
          title: 'Evidence First',
          desc: 'Every action we take is grounded in verifiable blockchain evidence. We never speculate — every claim is supported by documented, forensically sound data that can withstand legal scrutiny.'
        },
        {
          icon: '🛡️',
          title: 'Client Confidentiality',
          desc: 'Your case details, financial information, and identity are protected by military-grade encryption and strict internal confidentiality protocols. We never share your data — ever.'
        },
        {
          icon: '⚖️',
          title: 'Legal Integrity',
          desc: 'We operate strictly within legal and regulatory frameworks. Every recovery pathway we pursue is compliant, enforceable, and aligned with international financial crime law.'
        },
        {
          icon: '🌐',
          title: 'Global Accountability',
          desc: 'Fraud has no borders — and neither do we. Our international network of enforcement contacts, regulatory relationships, and exchange partnerships spans every major jurisdiction.'
        },
        {
          icon: '💡',
          title: 'Continuous Innovation',
          desc: 'The crypto fraud landscape evolves daily. We invest in the latest blockchain analytics platforms, threat intelligence feeds, and investigative methodologies to stay ahead of criminals.'
        },
        {
          icon: '🤝',
          title: 'Transparent Partnership',
          desc: 'We work with our clients as partners, not just case numbers. Regular updates, clear explanations, and honest assessments — you always know exactly where your case stands.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.core-values-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  position: relative;
  margin-bottom: 60px;
}

.tag {
  color: #00ff88;
  font-size: 0.9rem;
  letter-spacing: 2px;
  margin-bottom: 15px;
  font-weight: 600;
}

.title {
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 卡片网格 */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

/* 卡片样式 */
.card {
  position: relative;
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid #1f2937;
  border-radius: 10px;
  padding: 35px 30px;
  overflow: hidden;
  transition: transform 0.3s, border-color 0.3s;
}

.card:hover {
  border-color: #00ff88;
  transform: translateY(-5px);
}

/* 右上角水印数字 */
.card-num {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 4.5rem;
  font-weight: 800;
  color: rgba(37, 48, 69, 0.4);
  /* 半透明暗色数字 */
  pointer-events: none;
  user-select: none;
}

/* 图标框 */
.icon-box {
  width: 60px;
  height: 60px;
  background: #0a101f;
  border: 1px solid #253045;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.icon {
  font-size: 1.8rem;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 15px;
}

.card-desc {
  color: #a0b3cc;
  font-size: 1rem;
  line-height: 1.7;
  margin: 0;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>